import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { P } from '../AbstractElements'
export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <Container fluid>
                <Row>
                    <Col md={6} className="footer-copyright">
                        <P className="mb-0">{`Copyright ${currentYear} © Fintrack.`}</P>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}
